<template>
    <div class="pendencyBody">
        <CustomLoader v-if="isLoading" :width="70" />

        <b-card class="mainCardBG">
            <b-row>
                <b-navbar-nav>
                    <b-button @click="goBack" size="xxl" variant="light">
                        <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                    </b-button>
                </b-navbar-nav>

                <b-col md="8">
                    <h5 class="page-title mb-2">
                        <b>{{ $route.name }}</b>
                    </h5>
                </b-col>
            </b-row>

            <div class="mt-3">
                <!-- Search Form Input -->
                <b-row>
                    <b-col md="8" class="my-1">
                        <b-form-group>
                            <b-input-group>
                                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                                    placeholder="Type to Search Assignment" ref="search" />
                                <b-input-group-append class="mr-1">
                                    <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>

                            <b-col md="3">
                                <label><b> Created User Filter</b></label>
                                <model-list-select :list="$store.getters['common/getAllUserList']" id="addedUserFilter"
                                    @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                                    option-text="employeeName" placeholder="Select Created User" />
                            </b-col>
                        </b-form-group>
                    </b-col>

                    <b-col md="2">

                    </b-col>

                    <b-col md="2">
                        <h5>
                            <small v-if="!isLoading">{{ JOBList.length }} Entries</small>
                        </h5>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="my-1">
                        <b-button class="pull-right mb-1" v-if="JOBList.length > 0"
                            :disabled="ExcelBtnName !== 'Export As Excel'"
                            @click="getReports('checkJobPendency', 'Export As Excel')" size="sm" variant="warning"
                            style="font-size: 0.675rem">
                            {{ ExcelBtnName }}
                            <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small
                                label="Small Spinner"></b-spinner>
                        </b-button>
                        <b-pagination limit="5" :total-rows="JOBList.length" :per-page="paginationItem.perPage"
                            v-model="paginationItem.currentPage" class="my-0 pull-right" />
                    </b-col>
                </b-row>

                <!-- Table Section -->
                <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
                    <b-table show-empty stacked="md" responsive :fields="columnMain" :items="JOBList"
                        class="table-background position-relative" :per-page="paginationItem.perPage"
                        :current-page="paginationItem.currentPage" :filter="filter" @filtered="onFiltered">
                        <template slot="SN" slot-scope="row0">
                            <span>
                                {{ row0.index + 1 }}
                            </span>
                        </template>

                    </b-table>
                </div>
            </div>

        </b-card>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE_DOC } from "../../helper/constant.js";
import CommonService from "../../services/CommonService.js";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
    beforeMount() {
        this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({
                itemCode: "ClientList"
            })
        );
        this.lastVisitPage = this.$sessionsStorage.get("lastVisitPage");
        const loginId = this.$sessionsStorage.get("loginId");
        if (loginId) {
            this.$store.dispatch("setCurrentRoute", this.$route.path);
            this.getFailedPrealertList("Normal", "0", "0", "1", "1");
        } else {
            this.$router.push({ path: "/Login/" });
        }
    },

    data() {
        return {
        
            isLoading: false,
            docURL: URL_BASE_DOC,
            ExcelBtnName: "Export As Excel",
            Filter: { userFilter: this.$sessionsStorage.get("userId") },
            filter: "",
            JOBList: [],
            generateExcel: 0,
            modalType: 2,
            columnMain: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "HJ.",
                },
                {
                    key: "agent_type_agent_text",
                    mainkey: "agent_type_agent_text",
                    label: "Agent",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },
                {
                    key: "mainSalesSeries",
                    mainkey: "mainSalesSeries",
                    label: "Job No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "J.",
                },
                {
                    key: "shippingLine",
                    mainkey: "shippingLine",
                    label: "Sline",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "J.",
                },
                {
                    key: "shipper_name",
                    mainkey: "shipper_name",
                    label: "Shipper",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "J.",
                },
                {
                    key: "consignee",
                    mainkey: "consignee",
                    label: "Consignee",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "J.",
                },
                {
                    key: "house_bl_no",
                    mainkey: "house_bl_no",
                    label: "HBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "master_bl_no",
                    mainkey: "master_bl_no",
                    label: "MBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "preCreatedDate",
                    lmainkey: "preCreatedDate",
                    label: "Created Date",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "preCreatedBy",
                    lmainkey: "preCreatedBy",
                    label: "Created By",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "E.",
                },
                {
                    key: "clientName",
                    mainkey: "clientName",
                    label: "Client",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "isEmailSendStatus",
                    lmainkey: "isEmailSendStatus",
                    label: "Mail Status",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "E.",
                },
           
                {
                    key: "POR",
                    mainkey: "POR",
                    label: "POR - POL - POD",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },
                {
                    key: "POL",
                    mainkey: "POL",
                    label: "POL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "K.",
                },
                {
                    key: "POD",
                    mainkey: "POD",
                    label: "POD",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "L.",
                },

                {
                    key: "FPOD",
                    mainkey: "FPOD",
                    label: "FPOD",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

                {
                    key: "HBL",
                    mainkey: "HBL",
                    label: "HBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

                {
                    key: "MBL",
                    mainkey: "MBL",
                    label: "MBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

            ],
            paginationItem: {
                currentPage: 1,
                totalRows: 0,
                perPage: 50,
                pageOptions: [5, 10, 15],
            },
            validate: true,
        };
    },

    components: {
        ContainerSummary,
        JobWisePaymentsDetails,
        ContaierWebLogSummary,
        ModelListSelect,
        CustomLoader,
    },

    methods: {
        goBack() {
            window.history.go(-1);
        },

        getReports(id, btnName) {
            this.isLoading = true;
            this.generateExcel = "1";
            this.ExcelBtnName = "Downloading Please Wait .....";
            this.getFailedPrealertList("Excell", "0", "0", "1", "1");
        },
        getFailedPrealertList(type, filterId, CURRENT, SEARCH, pageNumber) {
            this.isLoading = type === "Normal";
            const payload = {
                type,
                DCfilterId: filterId,
                searchVal: this.filter,
                fromSearch: SEARCH,
                currentPage: CURRENT,
                perPage: this.paginationItem.perPage,
                Filter: this.Filter,
                generateExcel:this.generateExcel,
                isAllNo:1,
            };
            const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
            NodeLockPannelService.getAllFailedPrealertList(payload, config)
                .then((response) => {
                    const { data, status, statusText } = response;
                    console.log("data PS=>", data);
                    if (status == 200 && data) {
                        if (this.generateExcel == "1") {
                            // Handle file download
                            const blob = new Blob([data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", "get-Not-Billed-Container-panel-report.xlsx"); // Specify the file name
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            this.ExcelBtnName = "Export As Excel";
                            this.generateExcel = "0";
                            this.getFailedPrealertList("Normal", "0", "0", "1", "1");
                        } else {
                            if (data.data.length > 0) {
                                this.totalData = data.data.length;
                                this.JOBList = data.data;
                                this.paginationItem = {
                                    totalRows: data.data.length,
                                    perPage: 10,
                                }
                            }
                        }
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log("Catch on getContList Error: ", error);
                });
        },

        filterClear() {
            this.Filter = { userFilter: "" };
            this.getFailedPrealertList("Normal", "0", "0", "1", "1");
        },

        debounceSearch() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.getFailedPrealertList("Normal", "0", "0", "1", "1");
            }, 1000);
        },
        onFiltered(filtered) {
            this.paginationItem.totalRows = filtered.length;
            this.paginationItem.currentPage = 1;
        },
    },
};
</script>

<style>
.table-background thead {
    background-color: #a9e4ce;
    border: 2px solid lightgrey;
    position: sticky;
    top: 0;
    font-size: 11px;
}

.my-custom-scrollbar {
    height: 550px;
    overflow: auto;
}

.table-wrapper-scroll-y {
    display: block;
}

.status-alerts {
    font-size: 18px;
    flex-direction: column;
}

.alert {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    color: #fff;
}

.alert-danger-text {
    color: #d9534f;
}

.alert-info-text {
    color: #2a6fde;
}

@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

.blink {
    animation: blink 1s infinite;
    font-weight: 800;
    color: red;
}
</style>


// WEBPACK FOOTER //
// FailedPrealertList.vue?0230efa8